// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n#alert-system-bar a, #alert-system-bara:visited {\n\tcolor: #212121 !important;\n\tcaret-color: #212121 !important;\n\tfont-weight: bold;\n}\n#alert-system-bar p {\n\tmargin: 0;\n\tpadding: 0;\n}\n.hide-message .v-label {\n\tfont-size: 12px !important;\n\tmargin-right: 14px !important;\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
